module.exports = __webpack_public_path__ + "img/banner-advisoryboard@2x.7f77a874.jpg";